import { Card, Container, Row, Col, Spacer } from "@nextui-org/react";
import React from "react";
import { useState } from "react";
import ReactAnimatedWeather from 'react-animated-weather';
import WeatherIcon from "../weather-icon/weather-icon";
import WeatherTemperature from "../weather-temperature/weather-temperature";

export default function WeatherInfo(props) {

  const {
    ready,
    cityName,
    weatherTitle,
    weatherDescription,
    iconId,
    temperature,
    humidity,
    windSpeed,
    coordinates,
    time,
    name
  } = props.data;

    return(
        <>
        <Container>
          <Row align="center">
          <WeatherIcon id={iconId} size={48}/>
            <Col>
              <h1 className="heading current">{name}</h1>
              <p>{props.date}</p>
              <p className="status">{weatherTitle}</p>
            </Col>
            <Spacer y={1}/>
            <Col >
            <div className="temperature">
              <WeatherTemperature celsius={temperature}/>
          </div>
              <p className="weather__description">{weatherDescription}</p>
              <p className="weather__wind">wind: {windSpeed} km/h</p>
              <p id="humidity">humidity: {humidity} %</p>
            </Col>
          </Row>
        </Container>
        </>
    );
};



{/* <h3 className="heading current"></h3>
          <p className="status"></p>
          <div className="temperature">
          <strong id="temperature"></strong>
          <a id="celsius" className="temperature__link celsius active" href="#">
          ℃
          </a>
          <a id="fahrenheit" className="temperature__link fahrenheit" href="#">
          ℉
          </a>
          <div className="weather-details">
            <p className="weather__description">{props.data.description}</p>
            <p className="weather__wind">wind:</p>
            <p id="humidity">humidity:</p>
          </div> */}